import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { getRepoItems, saveRepoItem, deleteRepoItem } from "../services/contractRepoService";
import { ContractRepoDoc } from "../types/contractRepo";
import { ContractRepoForm } from "../modules/legal/forms/ContractRepoForm";
import { DataToolbar } from "../components/DataToolbar";
import { PreviewModal } from "../components/PreviewModal";

export function ContractRepoPage({ isLegacy = false }: { isLegacy?: boolean }) {
  const { user } = useAuth();
  const [items, setItems] = useState<ContractRepoDoc[]>([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState<ContractRepoDoc | null>(null);
  const [isFormOpen, setIsFormOpen] = useState(false);

  const fetch = async () => {
    if (!user) return;
    setLoading(true);
    const data = await getRepoItems(isLegacy ? "legacy" : "main", user);
    setItems(data);
    setLoading(false);
  };

  useEffect(() => { fetch(); }, [user, isLegacy]);

  const filtered = items.filter(i => 
    i.title.toLowerCase().includes(search.toLowerCase()) ||
    i.counterparty.toLowerCase().includes(search.toLowerCase()) ||
    i.number.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <div style={{ marginBottom: 16 }}>
        <input className="input" style={{ maxWidth: 400 }} placeholder="搜尋名稱、相對人、編號..." value={search} onChange={e => setSearch(e.target.value)} />
      </div>
      
      <DataToolbar 
        canEdit={true} 
        onCreate={() => { setSelected(null); setIsFormOpen(true); }} 
        onExport={() => alert("CSV 匯出功能開發中")} 
        title={isLegacy ? "舊合約清單" : "合約資料庫"} 
      />

      <div style={{ flex: 1, overflow: "auto" }}>
        {loading ? <div className="p">載入中...</div> : (
          <div style={{ display: "grid", gap: 10 }}>
            {filtered.map(item => (
              <div key={item.id} className="tile" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div>
                  <div style={{ fontSize: 13, color: "#fbbf24", fontFamily: "monospace" }}>{item.number}</div>
                  <div style={{ fontSize: 16, fontWeight: "bold", marginTop: 4 }}>{item.title}</div>
                  <div className="p" style={{ marginTop: 4 }}>對象: {item.counterparty} | 生效日: {item.effectiveDate}</div>
                </div>
                <div style={{ display: "flex", gap: 8 }}>
                  <button className="smallbtn" onClick={() => { setSelected(item); setIsFormOpen(true); }}>編輯</button>
                  <button className="smallbtn" style={{ color: "var(--danger)" }} onClick={async () => {
                    if (confirm("確定刪除？")) {
                      await deleteRepoItem(isLegacy ? "legacy" : "main", item.id!);
                      fetch();
                    }
                  }}>刪除</button>
                </div>
              </div>
            ))}
            {filtered.length === 0 && <div className="p" style={{ textAlign: "center", padding: 40 }}>無相符資料</div>}
          </div>
        )}
      </div>

      {isFormOpen && (
        <ContractRepoForm 
          initialData={selected} 
          isLegacy={isLegacy} 
          onClose={() => setIsFormOpen(false)} 
          onSave={async (data) => {
            await saveRepoItem(isLegacy ? "legacy" : "main", data);
            fetch();
          }} 
        />
      )}
    </div>
  );
}
 